<template>
    <div class="content-wrap sun res">
        <!-- 结果 -->
        <div class="success-wrap" v-if="isSuccess">
            <div class="total-score">
                <span>获得积分</span>
                <span>{{result.total_score}}分</span>
            </div>
            <p>答对{{result.correct_quiz_count}}题，共{{result.total_quiz_count}}题</p>
        </div>
        <div v-else class="fail-logo">
            <img src="../../../assets/sad.png"/>
            <p>挑战失败！</p><p>继续加油吧～</p>
        </div>
        <!-- 找回 -->
        <div class="buttons-wrap">
            <Button class="btn" @click="() => location.replace('/quiz')">返回</Button>
            <Button class="btn btn-warning" @click="handleFindBack" v-if="!isSuccess">找回{{result.total_score}}积分</Button>
            <Button class="btn btn-primary" @click="() => $router.go(0)" v-if="leftTime">再次挑战</Button>
        </div>
        <!-- 再次挑战 -->

        <div class="time-tip">
            <p v-if="leftTime">今日剩余{{leftTime}}次机会</p>
            <p v-else>今日挑战次数已用完</p>
        </div>

        <div class="qr-wrap">
            <!-- <img src="http://guokrapp-static.guokr.com/FtI3Eb6HAMzmX1zHmw_svJfYCmbt"/> -->
            <div class="img"></div>
            <p>
                <!-- 关注“农业科普发生树” -->
            </p>
            <p>
                <!-- 学习更多科普知识，获取更多积分～ -->
            </p>
        </div>

        <div class="share-mask" v-if="maskVisible" @click="maskVisible = false">
            <img src="http://guokrapp-static.guokr.com/FkB2W2sx63JkVduUVeEoodRNUK0O"/>
            <p>{{`
                点击右上角的“···”\n
                分享到朋友圈或发送给好友求助，\n
                若有人答对此题即可找回积分！
            `}}</p>
        </div>
    </div>
</template>

<script>
import { shareApi } from '@/apis'

import { Button } from 'vant';
export default {
    name: 'Res',
    props: ['result', 'leftTime'],
    components: {
        Button
    },
    data () {
        return {
            maskVisible: false
        }
    },
    computed: {
        isSuccess () {
            return this.result.type !== 'fail'
        },
    },
    methods: {
        handleCheck() {
            this.$emit('getQuesRes')
        },
        handleFindBack () {
            this.maskVisible = true
            shareApi.sharesPost({
                body: {
                    share_type: 'sun_help',
                    share_id: String(this.result.result_id)
                }
            })
        }
    },
    mounted () {
        if (this.result?.type === 'fail') {
            // 错误页才配置求助的分享
            this.onWxShare({
                title: `朝阳区公民科学素质大赛挑战模式翻车了，求帮助`,
                desc: '不小心答错了道题，积分全没前功尽弃，你能帮我找回积分吗？',
                link: `/quiz/help/${this.result.result_id}?quizId=${this.result.quizId}`
            })
        }
    }
};
</script>
<style lang="less" scoped>
.res {
    justify-content: center;
    .buttons-wrap {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: center;
        /deep/.van-button {
            flex: 0 0 35%;
            &.btn {
                min-width: 10.8rem;
            }
            &:first-child {
                margin-right: 2rem;
            }
            &:nth-child(3) {
                margin-top: 1.5rem;
            }
        }
    }
    .time-tip {
        p {
            margin-bottom: 0;
        }
    }
    .total-score {
        display: flex;
        position: relative;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 15.3rem;
        span {
            color: #123e7f;
            font-size: 16px;
            &:last-child {
                margin-top: 1rem;
                font-size: 3.6rem;
                font-weight: bold;
            }
            z-index: 1;
        }
        &::before{
            content: '';
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 13.1rem;
            height: 13.1rem;
            background: rgba(255, 255, 255, .8);
            border-radius: 100%;
            border: 1.1rem solid #fbd042;
        }
    }
    p {
        margin-top: 4vh;
        color: #fff;
        font-size: 16px;
        text-align: center;
    }
    .qr-wrap{
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-bottom: 1rem;
        .img{
            width: 20vh;
            height: 20vh;
            margin-top: 4vh;
            margin-bottom: 2vh;
        }
        p{
            margin:0;
            text-align: center;
            color: #123e7f;
            font-size: 16px;
            line-height: 1.5;
            height: 24px;
        }
    }
    .success-wrap {
        margin-bottom: 5vh;
    }
    .fail-logo {
        display: flex;
        margin-top: 10vh;
        margin-bottom: 5vh;
        flex-direction: column;
        justify-content: center;
        img {
            margin: auto;
            margin-bottom: 3vh;
            width: 26vw;
            height: 26vw;
        }
        p {
            font-weight: bold;
            margin: .2rem;
        }
    }

    .has-chance ~ .qr-wrap {
        img{
            margin-top: 1.5vh;
        }
    }

    .share-mask {
        position: fixed;
        background-color: rgba(0, 0, 0, 0.79);
        color: #fff;
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        img {
            align-self: flex-end;
            display: block;
            width: 5.15rem;
            margin: 2.3rem 2.3rem 0 0;
        }
        p {
            text-align: left;
            font-size: 16px;
            line-height: 1.5;
            white-space: pre-wrap;
        }
    }
}
</style>
